import { render, staticRenderFns } from "./crossExamination.vue?vue&type=template&id=089856b9&"
import script from "./crossExamination.vue?vue&type=script&lang=js&"
export * from "./crossExamination.vue?vue&type=script&lang=js&"
import style0 from "./crossExamination.vue?vue&type=style&index=0&id=089856b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports